<div class="container d-flex flex-column h-100">
  <div class="d-flex flex-column flex-grow-1">
    <div class="d-flex justify-content-center">
      <h3>Authorization Level</h3>
    </div>
    <mat-divider class="mb-3"></mat-divider>
    <div class="list-container">
      <h4>Line Of Business</h4>
      <div class="d-flex justify-content-start">
        <mat-radio-group aria-label="Line Of Business">
          <div class="d-flex flex-column">
            <mat-radio-button class="mb-2 ml-2" *ngFor="let lob of lineOfBusinessList" [value]="lob.role"
                              [name]="lob.role"
                              [checked]="lineOfBusiness ? lineOfBusiness === lob.role :
                              lineOfBusinessList.length > 0 && lineOfBusinessList[0].description === lob.description"
                              (change)="lineOfBusinessRules($event)">
              {{ lob.description }}
            </mat-radio-button>
          </div>
        </mat-radio-group>
      </div>
      <mat-divider class="mb-3"></mat-divider>
      <h4>Authorization Level</h4>
      <form [formGroup]="authorizationForm">
        <div class="mb-2" [hidden]="!applications.hasTransportation">
          <mat-slide-toggle formControlName="transportation" (change)="handleLocationsDialog(false)">
            Transportation - Third Party is granted access to Tracking and other movement of shipment related data.
          </mat-slide-toggle>
          <ng-container *ngTemplateOutlet="listLocations"></ng-container>
        </div>
        <div class="mb-2" [hidden]="!applications.hasECR">
          <mat-slide-toggle formControlName="emptyCarRequest" (change)="handleEcr(false)">
            Empty Car Request
          </mat-slide-toggle>
          <ng-container *ngTemplateOutlet="ecrData"></ng-container>
        </div>
        <div class="mb-2" [hidden]="!applications.hasRating">
          <mat-slide-toggle (change)="displayRatingConfirmation()" formControlName="rating">
            Rating - Third Party is granted access to Private and public rates relevant to customer
            releasing data as well as any other activities related to rating of shipments.
          </mat-slide-toggle>
        </div>
        <div class="mb-2">
          <mat-slide-toggle [hidden]="!applications.hasStorageAndLift" formControlName="storageAndLift" (change)="selectStorageAndLift($event)">
            Storage And Lift
          </mat-slide-toggle>
        </div>
        <div class="mb-2">
          <mat-slide-toggle [hidden]="!applications.hasRevenue" formControlName="revenue" (change)="selectRevenue($event)">
            Revenue (eFreightBill)
          </mat-slide-toggle>
        </div>
        <div>
          <mat-slide-toggle [hidden]="!applications.hasHljs" formControlName="hljs" (change)="selectHljs($event)">
            HLJS
          </mat-slide-toggle>
        </div>
        <div>
          <mat-slide-toggle [hidden]="!applications.hasRevenueClaims" formControlName="revenueClaims" (change)="selectRevenueClaims($event)">
            Revenue Claims Center - Third Party is granted access to the freight overcharge claim form and tracking of claims through the Revenue Claims Center.
          </mat-slide-toggle>
        </div>
      </form>
    </div>
  </div>
  <div class="d-flex justify-content-end pt-2">
    <button *ngIf="!(isEdit || isNewLob)" mat-stroked-button matStepperPrevious color="accent" class="mr-3" aria-label="Back Button">
      Back
    </button>
    <button mat-flat-button matStepperNext color="accent" aria-label="Preview Button" [disabled]="!oneValidApplication">
      Preview
    </button>
  </div>
</div>

<ng-template #listLocations>
  <ng-container *ngIf="displayLocations && authorizationForm.get('transportation')?.value &&
    !(selectedLineOfBusiness === imRole || selectedLineOfBusiness === offlineRole)">
    <div>
      <button mat-stroked-button color="accent" aria-label="Edit Button" (click)="handleLocationsDialog(true)">Edit</button>
    </div>
    <mat-nav-list style="max-height: 150px" class="overflow-auto">
      <mat-list-item *ngFor="let loc of selectedCustomer?.locations">
        <div class="container-fluid">
          <div class="row no-gutters" style="font-size: 14px">
            <div class="col-sm-3">
              <div>Class Code</div>
              <div class="p-1">{{ loc?.classCode || '--' }}</div>
            </div>
            <div class="col-sm-3">
              <div>Station Code</div>
              <div class="p-1">{{ loc?.stationCode || '--' }}</div>
            </div>
            <div class="col-sm-4">
              <div>Location Name</div>
              <div class="p-1">{{ loc?.locationName || loc?.stationName || '--' }}</div>
            </div>
            <div class="col-sm-2">
              <div>SCAC</div>
              <div class="p-1">{{ loc?.scac || '--' }}</div>
            </div>
          </div>
        </div>
      </mat-list-item>
    </mat-nav-list>
  </ng-container>
</ng-template>

<ng-template #ecrData>
  <ng-container *ngIf="ecrDetails && authorizationForm.get('emptyCarRequest')?.value">
    <div class="mb-1">
      <button mat-stroked-button color="accent" aria-label="Edit Button" (click)="handleEcr(true)">Edit</button>
    </div>
    <div class="bg-super-light p-2">
      <div class="my-1">Equipments:</div>
      <ul>
        <li *ngFor="let equipments of ecrDetails?.equipmentTypes || []"><strong>{{ equipments }}</strong></li>
      </ul>
      <div>Railroad Company: <strong>{{ ecrDetails?.railRoadCompanyEId }}</strong></div>
      <div>City and State: <strong>{{ ecrDetails?.railRoadLocCity }}, {{ ecrDetails?.railRoadLocState?.value }}</strong></div>
      <div>STCC: <strong>{{ ecrDetails?.stcc }}</strong></div>
    </div>
  </ng-container>
  <ng-container *ngIf="!ecrDetails && authorizationForm.get('emptyCarRequest')?.value">
    <div class="bg-super-light p-2">
      No Empty Car Request Data
    </div>
  </ng-container>
</ng-template>

<swal
  #swalConfirm
  title="Info"
  text="Are you sure you want to authorize this company to have access to your private rates and publications?"
  confirmButtonText="Confirm"
  denyButtonText="Cancel"
  [showDenyButton]="true"
  [reverseButtons]="true"
  [heightAuto]="false"
  (deny)="cancelRating()"
  (confirm)="acceptRating()"
>
</swal>
